var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham",style:({ height: '300px' }),attrs:{"columnDefs":_vm.columns,"rowData":_vm.lines,"rowSelection":"multiple"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }